import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";

export const fetchEntityListAction = async (pageNumber = 1, pageSize = 10, filters = {}) => {
    try {
        const { entityName, emailAddress, entityCategory, status } = filters;

        const params = {
            pageNumber,
            pageSize,
            ...(entityName && { EntityName: entityName }),
            ...(emailAddress && { EmailAddress: emailAddress }),
            ...(entityCategory && { EntityCategory: entityCategory }),
            ...(status && { Status: status }),
        };

        const response = await apiClient.get(ATP_API_URL.GET_ALL_DATA_SEARCH, { params });

        if (response?.status === 200 && response.data) {
            const responseData = response.data?.data || [];

            // Handle case where pagination is just a number (totalRecords)
            let totalRecords;
            if (typeof response.data.pagination === 'number') {
                totalRecords = response.data.pagination;
            } else {
                const serverPagination = response.data?.pagination || {};
                totalRecords = response.data?.totalRecords ||
                    serverPagination?.totalRecords ||
                    serverPagination?.totalItems ||
                    responseData.length;
            }

            // Calculate pagination based on totalRecords
            const calculatedTotalPages = Math.ceil(totalRecords / pageSize);

            const paginationData = {
                currentPage: pageNumber,
                totalPages: calculatedTotalPages,
                totalItems: totalRecords,
                pageSize: pageSize,
                hasNextPage: pageNumber < calculatedTotalPages,
                hasPreviousPage: pageNumber > 1
            };

            return {
                success: true,
                data: responseData,
                pagination: paginationData,
                message: "Entity list fetched successfully"
            };
        }

        return {
            success: false,
            data: [],
            pagination: {
                currentPage: 1,
                totalPages: 1,
                totalItems: 0,
                pageSize: pageSize,
                hasNextPage: false,
                hasPreviousPage: false
            },
            message: "Failed to fetch entity list"
        };
    } catch (error) {
        return {
            success: false,
            data: [],
            pagination: {
                currentPage: 1,
                totalPages: 1,
                totalItems: 0,
                pageSize: pageSize,
                hasNextPage: false,
                hasPreviousPage: false
            },
            message: error.message || "Failed to fetch entity list",
            error
        };
    }
};